import React from 'react';
import { Circle } from '@mui/icons-material';
import { Box, Divider, Typography } from '@mui/material';
import { DateFormats } from '@uplift/constants';
import { getDaysOverdue } from '@uplift/utils';
import { useCollaborativeStateDetailsQuery, useProviderSuperviseeQuery } from '@uplift/queries';
import { CalendarDateService } from '@uplift/services';
import { LightChip, SuperviseeProviderProfileGeneralInfo } from '@uplift/ui-v2';


export type SuperviseeDetailsProps = {
  superviseeId: string;
};


export const SuperviseeDetails: React.VFC<SuperviseeDetailsProps> = ({ superviseeId }) => {
  const { data: supervisee } = useProviderSuperviseeQuery(superviseeId);
  const { data: collaborativeStateDetails } = useCollaborativeStateDetailsQuery(supervisee?.stateId);

  if (!supervisee) return null;

  const formattedDueDate = CalendarDateService.format(supervisee.nextDueDate, DateFormats['MMM D, YYYY']);
  const daysOverdue = getDaysOverdue(supervisee.nextDueDate);
  const isPastDue = daysOverdue > 0;

  return (
    <>
      <SuperviseeProviderProfileGeneralInfo supervisee={supervisee} />
      <Divider />
      {collaborativeStateDetails?.requiresSupervisionMeeting && (
        <Box sx={{ p: 4 }}>
          <Typography variant="overline" color="secondary" sx={{ fontWeight: 600 }}>
            Next Supervision Meeting Due
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 'normal' }}>
            {formattedDueDate}
          </Typography>
          {isPastDue && (
            <LightChip
              size="small"
              color="error"
              icon={<Circle sx={{ fontSize: '8px !important' }} />}
              label={`Past due by ${daysOverdue} days`}
              sx={{ mt: 1 }}
            />
          )}
        </Box>
      )}
    </>
  );
};
